import { render, staticRenderFns } from "./EventPerson.vue?vue&type=template&id=7b72bba5&"
import script from "./EventPerson.vue?vue&type=script&lang=js&"
export * from "./EventPerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports